// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
//
import { HeaderSimple as Header } from '../_common';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompactInterviewLayout({ children }: Props) {
  return (
    <>
      <Container component="main" maxWidth={false} sx={{
            paddingLeft: 0,
            paddingRight: 0,
            '@media (min-width: 600px)': {
              paddingLeft: `${0}!important`,
              paddingRight: `${24}px !important`,
            },
            position: 'relative',
            '&:before': {
              width: 1,
              height: 1,
              zIndex: -1,
              content: "''",
              position: 'absolute',
              backgroundSize: 'cover',
              opacity: 0.24,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
              backgroundImage: 'url(/assets/background/overlay_4.jpg)',
            },
          }}>
        <Stack
          sx={{
            m: 'auto',
            maxWidth: { xs: '90%', sm: '80%', md: '75%', lg: '60%', xl: '50%' },
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}
